window['moment-range'].extendMoment(moment);
